import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./auth-store/auth-slice";
import dashSlice from "./dash-store/dash-slice";
import UISlice from "./ui-slice";


const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    dash: dashSlice.reducer,
    ui: UISlice.reducer
  },
});

export default store;
